import React, { useState, useContext, useEffect } from "react";
import ParetoChart from "../../components/Charts/BarChart/BarChart";
import { Link } from "react-router-dom";
import { ssoData, ssoCsrData, ssoCacData } from "../SsoPage/ssoKPI/SSOKpi";
import { FilterContext } from "../../context/Filter";

const SsoPage = ({
  activeSSO,
  setActiveSSO,
  totalSsoData,
  setSsoData,
  searchData,
  selectedValues,
}) => {
  // const [totalSsoData, setSsoData] = useState(null);
  // const { searchData, clicked } = useContext(FilterContext);

  const fetchSSO = async (searchData) => {
    // console.log(searchData);
    try {
      // setLoading(true);
      const apiData = await ssoData(searchData);

      if (!apiData) {
        console.error("API response is empty or invalid:", apiData);
        return;
      }
      setSsoData(apiData);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setSsoData([]);
    } finally {
      // setLoading(false);
    }
  };

  const fetchSSOWorkShop = async (searchData) => {
    try {
      
      const apiData = await ssoCacData(searchData);

      if (!apiData) {
        console.error("API response is empty or invalid:", apiData);
        return;
      }
      setSsoData(apiData);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setSsoData([]);
    } finally {
      // setLoading(false);
    }
  };

  const fetchSSOEnrout = async (searchData) => {
    
    try {
      // setLoading(true);
      const apiData = await ssoCsrData(searchData);
      if (!apiData) {
        console.error("API response is empty or invalid:", apiData);
        setSsoData({ result: [] });
        return;
      }
      setSsoData(apiData);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setSsoData([]);
    } finally {
      // setLoading(false);
    }
  };
// console.log(searchData,'-----------------------');
  useEffect(() => {
    // fetchSSO(searchData);
    if (activeSSO === "SSO Total Complaints") {
      fetchSSO( searchData );
    }
    if (activeSSO === "SSO Workshop Complaints") {
      fetchSSOWorkShop(searchData);
    }
    if (activeSSO === "SSO Enroute Complaints") {
      fetchSSOEnrout(searchData);
    }
  }, [activeSSO]);

  const handleClickSSO = () => {
    setActiveSSO("SSO Total Complaints");
    // fetchSSO(searchData);
  };

  const handleClickWorkShop = () => {
    setActiveSSO("SSO Enroute Complaints");
    // fetchSSOWorkShop(searchData);
  };

  const handleClickEnrout = () => {
    
    setActiveSSO("SSO Workshop Complaints");
    // fetchSSOEnrout(searchData);
  };
  const sso = totalSsoData?.result ?? [];
  // console.log(sso);
  return (
    <div className="">
      <div className=" text-sm flex gap-2 items-center w-full justify-center mt-2">
        <Link
          to={"/sso"}
          onClick={handleClickSSO}
          className={`bg-gradient-to-r from-[#196FB9] to-[#379BDB] hover:bg-blue-800 focus:ring-4 text-white p-2 rounded-lg text-center justify-items-center text-sm max-w-80 w-full ${
            activeSSO === "SSO Total Complaints" && "border-4 border-white"
          }`}
        >
          Total Complaints
        </Link>
        <Link
          to={"/sso"}
          onClick={handleClickEnrout}
          className={`bg-gradient-to-r from-[#196FB9] to-[#379BDB] hover:bg-blue-800 focus:ring-4 text-white p-2 rounded-lg text-center justify-items-center text-sm max-w-80 w-full ${
            activeSSO === "SSO Workshop Complaints" && "border-4 border-white"
          }`}
        >
          <button className="">Workshop Complaints</button>
        </Link>

        <Link
          to={"/sso"}
          onClick={handleClickWorkShop}
          className={`bg-gradient-to-r from-[#196FB9] to-[#379BDB] hover:bg-blue-800 focus:ring-4 text-white p-2 rounded-lg text-center justify-items-center text-sm max-w-80 w-full ${
            activeSSO === "SSO Enroute Complaints" && "border-4 border-white"
          }`}
        >
          <button className="">En-route Complaints</button>
        </Link>
      </div>
      <ParetoChart data={sso} isChanged={false} activeSSO={activeSSO} />
    </div>
  );
};

export default SsoPage;
